module.exports = function(context, args){
  return new (Function.prototype.bind.apply(context, args));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/jpex/src/instantiator.js
// module id = MyNU
// module chunks = 0